// Making drop-down menus the same width as their parent
$(document).ready(function() {
  $('#header .d-md-block .dropdown-menu').on('show.bs.dropdown', function() {
    console.log($(this));
    console.log('something');
    $(this).dropdown('update');
  });
});